/**
 * vergiNo.js: vergi numarası biçim kontrolü (backlog #197).
 *
 * Backend'deki FirmaService.normalizeTaxNumber ile AYNI kural. Backend yine de kontrol ediyor; bu
 * yalnızca kullanıcıya kaydetmeden önce söylemek için:
 *   - boşluklar atılır; boş değer = "girilmedi" (geçerli; vergi no zorunlu değil, alan NULL olabilir)
 *   - Yerli firma: yalnızca rakam, 10 hane (VKN) ya da 11 hane (TCKN, şahıs şirketi)
 *   - Yabancı firma: biçim serbest, en fazla 50 karakter (firma.tax_number VARCHAR(50))
 * Sağlama hanesi (checksum) kontrolü yok, backend'de de yok.
 */

import i18n from "../../i18n";

export const VERGI_NO_MAX = 50;

/** Kaydedilecek biçim: boşluksuz. */
export function vergiNoTemizle(raw) {
  return String(raw ?? "").replace(/\s+/g, "");
}

/**
 * @param {string}  raw    kullanıcının yazdığı
 * @param {boolean} yerli  firma Yerli mi (firma_nation 1)
 * @returns {string|null}  hata metni, geçerliyse null
 */
export function vergiNoHatasi(raw, yerli) {
  const v = vergiNoTemizle(raw);
  if (v === "") return null;
  if (yerli) {
    return /^(\d{10}|\d{11})$/.test(v)
      ? null
      : i18n.t("components:vergiNo.n10HaneliVknYaDa");
  }
  // WAS (until #622): `En fazla ${VERGI_NO_MAX} karakter.` - a bare Turkish literal (rule #13).
  return v.length > VERGI_NO_MAX ? i18n.t("components:vergiNo.enFazlaKarakter", { max: VERGI_NO_MAX }) : null;
}
